import { ref } from 'vue';

/**
 * Popover com gatilho: abrir, fechar e DEVOLVER O FOCO ao controle que o
 * abriu (WCAG 2.4.3). Sem isso, escolher uma opção ou pressionar Escape
 * desmonta o botão focado junto com o painel e o foco cai em BODY — quem
 * navega por teclado volta ao início da página.
 *
 * O board tem cinco popovers com esse mesmo formato (mover card, funil,
 * período, e os filtros múltiplos) e a devolução de foco existia em um só:
 * o padrão vive aqui para que o sexto não repita o defeito.
 *
 * `close` sozinho NÃO devolve o foco, e é o que o clique fora usa: nesse
 * caso o foco já foi para onde a pessoa clicou, e trazê-lo de volta ao
 * gatilho roubaria esse foco.
 *
 * @returns {Object} estado e ações do popover.
 */
export function usePopoverTrigger() {
  const isOpen = ref(false);
  const triggerRef = ref(null);

  const toggle = () => {
    isOpen.value = !isOpen.value;
  };

  const close = () => {
    isOpen.value = false;
  };

  // $el cobre o gatilho que é um componente (NextButton); o próprio valor
  // cobre o gatilho que já é um elemento nativo.
  const focusTrigger = () => {
    const element = triggerRef.value?.$el ?? triggerRef.value;
    element?.focus?.();
  };

  const closeAndFocusTrigger = () => {
    close();
    focusTrigger();
  };

  return {
    isOpen,
    triggerRef,
    toggle,
    close,
    focusTrigger,
    closeAndFocusTrigger,
  };
}
